import { useState } from "react";
import { motion } from "framer-motion";
import { LuLogIn } from "react-icons/lu";
import FloatingInput from "../../../common/FloatingInput";
import FloatingPasswordInput from "../../../common/FloatingPasswordInput";
import Button from "../../../common/Button";
import { containerVariants, itemVariants } from "../../../common/MotionVariants";

export default function LoginForm({ onSubmit, loading, error, onForgotPassword, onRegisterOrg }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(email, password);
  };

  return (
    <motion.form
      onSubmit={handleSubmit}
      className="flex flex-col gap-5"
      noValidate
      variants={containerVariants}
      initial="hidden"
      animate="show"
    >
      <motion.div variants={itemVariants}>
        <FloatingInput
          id="email"
          label="Email address"
          required
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoComplete="email"
        />
      </motion.div>

      <motion.div variants={itemVariants}>
        <FloatingPasswordInput
          id="password"
          label="Password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </motion.div>

      {error && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          className="overflow-hidden rounded-md border border-rose-500/20 bg-rose-500/10 px-3.5 py-2.5 text-sm font-medium text-rose-300"
        >
          {error}
        </motion.div>
      )}

      <motion.div
        variants={itemVariants}
        className="flex flex-wrap items-center justify-between gap-2 text-sm"
      >
        <button
          type="button"
          onClick={onForgotPassword}
          className="font-medium text-[#8CA0FF] transition-colors hover:text-[#B4C2FF] underline-offset-2 hover:underline"
        >
          Forgot password?
        </button>
        <button
          type="button"
          onClick={onRegisterOrg}
          className="font-medium text-[#8CA0FF] transition-colors hover:text-[#B4C2FF] underline-offset-2 hover:underline"
        >
          Register organization
        </button>
      </motion.div>

      <motion.div variants={itemVariants}>
        <Button type="submit" icon={LuLogIn} variant="accent" loading={loading}>
          Sign in
        </Button>
      </motion.div>
    </motion.form>
  );
}